// extracted by mini-css-extract-plugin
export default {"InstallmentAnticipationDetails__actionButtons":"InstallmentAnticipationDetails_InstallmentAnticipationDetails__actionButtons__O7oAm"};